// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse {
    static getAttributeTypeMap() {
        return ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.attributeTypeMap;
    }
}
ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.discriminator = undefined;
ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.additionalProperties = false;
ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.js.map